export const NEW_DASHBOAD_SCORECOUNT = "NEW_DASHBOAD_SCORECOUNT"
export const NEW_DASHBOAD_SCORECOUNT_SUCCESS = "NEW_DASHBOAD_SCORECOUNT_SUCCESS"
export const NEW_DASHBOAD_SCORECOUNT_FAIL = "NEW_DASHBOAD_SCORECOUNT_FAIL"
export const CLEAR_NEW_DASHBOARD_SCORECOUNT = "CLEAR_NEW_DASHBOARD_SCORECOUNT"